import React, { useState, useEffect, useRef } from 'react';

const MyComponent = () => {
  const [isTop, setIsTop] = useState(true);  // Button to scroll up
  const [isBottom, setIsBottom] = useState(false); // Button to scroll down
  const scrollContainerRef = useRef(null); // Ref for the scrollable container

  // Scroll up by a small amount
  const scrollTop = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        top: -50, // Scroll up by 50px
        behavior: 'smooth', // Smooth scroll
      });
    }
  };

  // Scroll down by a small amount
  const scrollBottom = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        top: 50, // Scroll down by 50px
        behavior: 'smooth', // Smooth scroll
      });
    }
  };

  // Update button states based on scroll position
  const updateButtonState = () => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      setIsTop(container.scrollTop === 0); // True if at the top of the container
      setIsBottom(container.scrollHeight - container.scrollTop === container.clientHeight); // True if at the bottom
    }
  };

  // Add event listener to check scroll position
  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      // Listen for scroll events to update button states
      container.addEventListener('scroll', updateButtonState);
    }

    // Cleanup the event listener when the component is unmounted
    return () => {
      if (scrollContainerRef.current) {
        scrollContainerRef.current.removeEventListener('scroll', updateButtonState);
      }
    };
  }, []);  // Empty array means this effect runs once when the component mounts

  return (
    <div className="App" style={{ height: '500px', overflowY: 'auto' }} ref={scrollContainerRef}>
      <div style={{ marginTop: '10px' }}>
        <button onClick={scrollTop} disabled={isTop}>Scroll Up</button>
        <button onClick={scrollBottom} disabled={isBottom}>Scroll Down</button>
      </div>

      {/* Your table or other content goes here */}
      <div style={{ height: '2000px' }}> {/* Simulating large content for scrolling */} 
        {/* Replace with actual content */}
        <p>Scroll me!</p>
      </div>
    </div>
  );
};

export default MyComponent;
